import { z } from 'zod';
import { AlertSubscriptionSchema } from '../base.js';
export const DeleteAlertSubscriptionBodyRequestSchema = AlertSubscriptionSchema.pick({
    alertLevel: true,
    email: true,
});
export const DeleteAlertSubscriptionRequestSchema = DeleteAlertSubscriptionBodyRequestSchema;
export const DeleteAlertSubscriptionResponseSchema = z.void();
